import { ExportEmailDrawerTranslations } from "./export-email-drawer-pt-br";

export const EXPORT_EMAIL_DRAWER_ES_MX: ExportEmailDrawerTranslations = {
	title: "Exportaciones",
	description:
		"Informe el correo electrónico para recibir la planilla. La planilla será enviada en unos minutos y también estará disponible en 'Planillas exportadas' por 7 días.",
	form: {
		label: "Correo electrónico",
		placeholder: "Ingrese su correo electrónico",
		required: "El correo electrónico es obligatorio",
		emailInvalid: "El correo electrónico no es válido",
		submit: "Exportar planilha",
	},
};
